module.exports = __webpack_public_path__ + "img/motorway_9x3_z18.485b33ed.svg";